export const NEW_OFFER = 1
export const DOCUMENT_UPDATE = 2
export const CHAT_EXPORTED = 3
export const HELPDESK = 4
export const LOGS_EXPORTED = 5
export const REPORT_EXPORTED = 7
